import { Link } from 'react-router-dom';
import { FormikValues, useFormikContext } from 'formik';

import { Routes } from 'config';

import { Button } from '../button';

import { AuthActionFooterProps } from './types';

export const AuthActionFooter = <T extends FormikValues>({
  confirmButtonText,
  footerText = 'Back to',
  link = Routes.Auth.Login,
  footerButtonText = 'Sign In',
}: AuthActionFooterProps) => {
  const { dirty, isSubmitting } = useFormikContext<T>();

  return (
    <div className="flex flex-col gap-4">
      <Button type="submit" disabled={!dirty || isSubmitting}>
        {confirmButtonText}
      </Button>

      <div className="flex items-center justify-center gap-1">
        <p>{footerText}</p>
        <Button
          to={link}
          variant="text"
          component={Link}
          buttonClassName="h-auto min-w-0 p-0"
        >
          {footerButtonText}
        </Button>
      </div>
    </div>
  );
};
